import { render, staticRenderFns } from "./NewsFeatureGroupsList.vue?vue&type=template&id=da8104bc"
import script from "./NewsFeatureGroupsList.js?vue&type=script&lang=js&external"
export * from "./NewsFeatureGroupsList.js?vue&type=script&lang=js&external"
import style0 from "./NewsFeatureGroupsList.vue?vue&type=style&index=0&id=da8104bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports